export default __webpack_public_path__ + "static/media/rocket_anim_103.e058dd3a.png";